import React from 'react';

export const MinusCircleIcon = ({ color, iconSize, onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={iconSize ?? '24'}
    height={iconSize ?? '24'}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ?? 'black'}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-minus-circle"
    onClick={onClick}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);
